import { useTimeZone } from '../../../hooks'
import { NavArrows } from '../../NavArrow'

import { fromMonths, toMonths } from './MonthYearSpinInput.utils'

import * as styles from './MonthYearSpinInput.module.css'

/**
 * The {@link MonthYearSpinInput} component represents the common
 * {@link NavArrows} component for {@link MonthSpinInput} and
 * {@link YearSpinInput}
 */
function MonthYearSpinInput({
  Component = NavArrows,
  className = styles.MonthYearSpinInput,
  maxValue,
  minValue,
  value,
  onChange,
  ...componentProps
}) {
  const timeZone = useTimeZone()

  function handleChange(nextValue) {
    onChange?.(fromMonths(timeZone, nextValue))
  }

  return (
    <Component
      {...componentProps}
      className={className}
      maxValue={toMonths(maxValue)}
      minValue={toMonths(minValue)}
      value={toMonths(value)}
      onChange={handleChange}
    />
  )
}

export default MonthYearSpinInput
